// extracted by mini-css-extract-plugin
export default {"richTextarea":"richTextarea_richTextarea__oCL1R","formatToolbar":"richTextarea_formatToolbar__YY-0g"};